import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-168b8c46"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref, PropType, onMounted } from 'vue'
import IDialog from "@/components/dialog/IDialog.vue"
import { modalTypes } from "@/components/dialog/modalTypes"
import { WorkflowState } from "@/models/workflow-state";
import { useI18n } from "vue-i18n";
import IButton from '@/components/buttons/IButton.vue';
import { ISlide } from '@/models/slide';
import { useStore } from 'vuex'
import { RootActions } from "@/store/actions";
import { log } from "@/core/logger";
import { AxiosError } from 'axios'
import { EventBus } from '@/eventBus';

// store

export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteSlideDialog',
  props: {
  slide: {
    type: Object as PropType<ISlide>
  }
},
  emits: ['close', 'confirm'],
  setup(__props, { emit }) {

const props = __props;

const store = useStore()

// emits


// props


// i18n
const { t } = useI18n({
  inheritLocale: true,
  useScope: "local",
});

// modal flags
const completedSlideDialog = ref(false)
const confirmDeleteDialog = ref(false)
const inProgressDialog = ref(false)
const slideDeletionFailDialog = ref(false)
const slideReportDeletionFailDialog = ref(false)

// methods
const handleReportFail = (error: Error | AxiosError) => {
  inProgressDialog.value = false
  slideReportDeletionFailDialog.value = true
  throw {
    msg: 'Slide report deletion failed',
    error
  }
}
const handleDeleteFail = (error: Error | AxiosError) => {
  inProgressDialog.value = false
  slideDeletionFailDialog.value = true
  throw {
    msg: 'Slide deletion from GAPI failed',
    error
  }
}
const deleteSlide = async () => {
  try {
    confirmDeleteDialog.value = false
    inProgressDialog.value = true
    await store.dispatch(RootActions.DELETE_SLIDE_REPORT, {slideId: props.slide.slideId}).catch(handleReportFail)
    await store.dispatch(RootActions.DELETE_SLIDE, {slideId: props.slide.slideId}).catch(handleDeleteFail)
    await store.dispatch(RootActions.CONSTRUCT_CASES_DATA)
    EventBus.emit('update-case', {caseId: store.state.activeCaseId});
  }
  catch (error) {
    log('DeleteSlideDialog', error)
  }
  finally {
    inProgressDialog.value = false
  }
}

onMounted( () => {
  switch(props.slide.workflowState) {
    case WorkflowState.NOT_SET:
    case WorkflowState.INCOMPLETE:
      confirmDeleteDialog.value = true
      break;
    case WorkflowState.COMPLETE:
      completedSlideDialog.value = true
      break;
  }
})


return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (confirmDeleteDialog.value)
    ? (_openBlock(), _createBlock(IDialog, {
        key: 0,
        title: _unref(t)('slides.deleteModal.incomplete.title'),
        onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('close'))),
        type: _unref(modalTypes).WARNING
      }, {
        body: _withCtx(() => [
          _createVNode(_component_i18n_t, {
            tag: "p",
            keypath: "slides.deleteModal.incomplete.body"
          }, {
            slideid: _withCtx(() => [
              _createElementVNode("strong", null, _toDisplayString(__props.slide.slideId), 1)
            ]),
            deletewarning: _withCtx(() => [
              _createElementVNode("strong", null, _toDisplayString(_unref(t)('slides.deleteModal.incomplete.warning')), 1)
            ]),
            newline: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        footer: _withCtx(() => [
          _createVNode(IButton, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close'))),
            text: _unref(t)('modal.action.cancel'),
            themeColor: "secondary"
          }, null, 8, ["text"]),
          _createVNode(IButton, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (deleteSlide())),
            text: _unref(t)('modal.action.delete')
          }, null, 8, ["text"])
        ]),
        _: 1
      }, 8, ["title", "type"]))
    : (completedSlideDialog.value)
      ? (_openBlock(), _createBlock(IDialog, {
          key: 1,
          title: _unref(t)('slides.deleteModal.complete.title'),
          onClose: _cache[4] || (_cache[4] = ($event: any) => (emit('close'))),
          type: _unref(modalTypes).ERROR
        }, {
          body: _withCtx(() => [
            _createVNode(_component_i18n_t, {
              tag: "p",
              keypath: "slides.deleteModal.complete.body"
            }, {
              newline: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          footer: _withCtx(() => [
            _createVNode(IButton, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('close'))),
              text: _unref(t)('modal.action.ok')
            }, null, 8, ["text"])
          ]),
          _: 1
        }, 8, ["title", "type"]))
      : (inProgressDialog.value)
        ? (_openBlock(), _createBlock(IDialog, {
            key: 2,
            title: _unref(t)('slides.deleteModal.incomplete.title'),
            onClose: _cache[5] || (_cache[5] = ($event: any) => (emit('close'))),
            type: _unref(modalTypes).WARNING,
            closeIcon: false
          }, {
            body: _withCtx(() => [
              _createVNode(_component_i18n_t, {
                tag: "p",
                keypath: "slides.deleteModal.progress.body"
              }, {
                newline: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            footer: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["title", "type"]))
        : (slideReportDeletionFailDialog.value)
          ? (_openBlock(), _createBlock(IDialog, {
              key: 3,
              title: _unref(t)('slides.deleteModal.complete.title'),
              onClose: _cache[8] || (_cache[8] = ($event: any) => (emit('close'))),
              type: _unref(modalTypes).ERROR
            }, {
              body: _withCtx(() => [
                _createVNode(_component_i18n_t, {
                  tag: "p",
                  keypath: "slides.deleteModal.reportDeletionFail.body"
                }, {
                  newline: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              footer: _withCtx(() => [
                _createVNode(IButton, {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (emit('close'))),
                  text: _unref(t)('modal.action.close'),
                  themeColor: "secondary"
                }, null, 8, ["text"]),
                _createVNode(IButton, {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (deleteSlide())),
                  text: _unref(t)('modal.action.retry')
                }, null, 8, ["text"])
              ]),
              _: 1
            }, 8, ["title", "type"]))
          : (slideDeletionFailDialog.value)
            ? (_openBlock(), _createBlock(IDialog, {
                key: 4,
                title: _unref(t)('slides.deleteModal.complete.title'),
                onClose: _cache[11] || (_cache[11] = ($event: any) => (emit('close'))),
                type: _unref(modalTypes).ERROR
              }, {
                body: _withCtx(() => [
                  _createVNode(_component_i18n_t, {
                    tag: "p",
                    keypath: "slides.deleteModal.deletionFail.body"
                  }, {
                    newline: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                footer: _withCtx(() => [
                  _createVNode(IButton, {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (emit('close'))),
                    text: _unref(t)('modal.action.close'),
                    themeColor: "secondary"
                  }, null, 8, ["text"]),
                  _createVNode(IButton, {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (deleteSlide())),
                    text: _unref(t)('modal.action.retry')
                  }, null, 8, ["text"])
                ]),
                _: 1
              }, 8, ["title", "type"]))
            : _createCommentVNode("", true)
}
}

})